import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { Config } from "../constant";
import { send, sendWithSession, StartTimerForTimeout } from "../Socket";
import { observer } from "mobx-react";
import Flag from "../assets/Flag.png";
import "../index.css";
import CaptchaField from "./CaptchaField";
import { CustomerInitiatesChat } from "../model/Outgoing";
import Axios from "axios";
import * as yup from 'yup';
import "yup-phone";
import { CommonStore, EnableCreateSession, SendingInitRoom, UpdateFirstMessage } from "../Store";
import CloseToolbar from "../module-common/CloseToolbar";
import qs from "qs";

const customInputStyle = {
  borderBottom: "none",
  marginBottom: "3px"
};

class InputWithLabel extends Component {


  render() {
    const { label, name, value, onChange, errorMessage, textarea, maxCount = 300 } = this.props
    
    let input = null
    if(textarea) {
      const fractionOfMax = value.length / maxCount
      const isRed = fractionOfMax >= 0.9
      const isYellow = fractionOfMax >= 0.7 && fractionOfMax < 0.9
      input = (
        <div style={{width: '100%'}} >
          <textarea
            style={{width: '100%', resize: 'none'}}
            value={value}
            onChange={onChange}
            name={name}
            row={12}
          >
          </textarea>
          <span style={{marginTop: 5,float: 'right', color: isRed ? 'red' : isYellow ? 'yellow' : 'white', fontSize: 12, }}>{maxCount - value.length}/{maxCount}</span>
        </div>
      )
    } else {
      input = (<Input
        name={name}
        value={value}
        type="text"
        placeholder={label}
        onChange={onChange}
      />)
    }
    return (<Fragment>
      <div>
        <Label>{label}</Label>
        {errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
      </div>
      {input}
    </Fragment>)
  }
}


const Label = styled.label`
  color: white;
  margin: 0 0 5px 0;
  font-size: 0.75em;
  font-family: "Source Sans Pro", sans-serif;
  @media (max-width: 430px) {
    color: white;
    margin: 0 0 2% 0;
    font-family: "Source Sans Pro", sans-serif;
  }
`;

const ErrorLabel = styled.span`
  color: red;
  margin: 0 0 5px 0;
  text-align: right;
  font-size: 0.75em;
  font-family: "Source Sans Pro", sans-serif;
  float: right;
`

const Input = styled.input`
  background-color: transparent;
  border: 0px;
  border-bottom: solid 2px white;
  margin-bottom: 10px;
  padding: 3px;
  color: #ffffff;
  font-size: 0.7em;
  line-height: 1.5;
  font-family: "Source Sans Pro", sans-serif;
  ::placeholder {
    color: white;
    opacity: 0.3364;
  }
  &:focus {
    font-weight: bold;
    outline: none;
  }
`;

export default InputWithLabel